/* eslint-disable */
import { Component } from 'react';
import { Images, Utils, _, Trans } from 'Helpers';
import { Button, UncontrolledPopover, PopoverBody, Alert } from 'reactstrap';
import { ReduxHOC } from 'HOC';
import Banner from 'Components/Banner';
class Booster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      booster_list: [],
      team_info: {},
      selected_league: Utils.getMultiLeg(),
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      joined_week,
      last_week,
      active_week,
      next_week,
      updateBooster,
      booster_list,
      team_info,
      SelectedWeek,
    } = nextProps;
    const { t } = this.props

    
      this.setState({
        booster_list: booster_list ,
        team_info: team_info,
        next_week: next_week,
        active_week: active_week,
        last_week: last_week,
        joined_week: joined_week,
        SelectedWeek: SelectedWeek,
      },()=>{
        
      })
   // }
  }
 
  isAlreadyApplyied = (init_type) => {
  const { t } = this.props;
  const { team_info, booster_list, next_week, last_week, joined_week, active_week } = this.state;
  if (!team_info) return null;

  const booster_type = {
    1: 'captain_booster_status',   // Triple Captain
    2: 'bench_booster_status',     // Bench Boost
    3: 'free_hit_booster_status',  // Free Hit
    ...((active_week >= joined_week && last_week !== next_week && active_week !== next_week)
      ? { 4: 'wildcard_status' }    // Wild Card
      : {})
  };

  let status = false;

  for (let i = 0; i < booster_list.length; i++) {
    let info = { ...team_info[booster_type[booster_list[i].type]], type: booster_list[i].type };

    // Only check boosters that are already applied for the upcoming week
    if (info.applied_week == next_week) {
      
      // Same booster already applied
      if (info.type === init_type) {
        status = true;
        break;
      }

      // RULE 1: Free Hit must be used alone
      if (init_type === 3 || info.type === 3) {
        Utils.notify(t('Free Hit cannot be combined with any other booster'), 'error');
        status = true;
        break;
      }

      // RULE 2: Bench Boost & Triple Captain cannot be together
      if ((init_type === 1 && info.type === 2) || (init_type === 2 && info.type === 1)) {
        Utils.notify(t('Bench Boost and Triple Captain cannot be used together'), 'error');
        status = true;
        break;
      }

      // RULE 3: Wild Card cannot be used with Free Hit
      if ((init_type === 0 && info.type === 3) || (init_type === 3 && info.type === 0)) {
        Utils.notify(t('You cannot apply Wild Card with Free Hit in the same week'), 'error');
        status = true;
        break;
      }
    }
  }

  return status;
};


  render() {
    const {
      ApplyBooster,
      RemoveBooster,
      BoosterPosting,
      joined_week,
      last_week,
      active_week,
      LineupList,
      read_only,
      IS_MYTEAM,
      lineup_master_id,
      IS_FROM_LEADER
    } = this.props;
    let { SelectedWeek, booster_list, selected_league, team_info, next_week } = this.state;
    
    return (
      <div className={`${IS_MYTEAM && !_.isUndefined(lineup_master_id) ? 'booster-wrap lineup-alter' : "booster-wrap"} ${_.isEmpty(booster_list) ? 'empty-boost' : ''}`}>
        {
          team_info &&
          _.map(booster_list, (item, idx) => {
            if (!item) return null

            return (
              
              <div
                id={`BoosterType${item.type}`}
                {
                ...{
                  className: `booster-item
                   ${(item.is_applied == 0 || item.applied_week > SelectedWeek) ?
                      '' :
                      `${item.applied_week == SelectedWeek && 'applied'} ${item.applied_week < SelectedWeek && 'played'}`
                    }
                   `,
                  key: idx,
                  style: { display: read_only ? (item.applied_week == SelectedWeek ? 'inline-flex' : 'none') : 'inline-flex' }
                }
                }>
                <img src={Images[`BOOSTER_${item.type}`]} alt="" />
                <div className='cell'>
                  <div>

                    {
                      (item.is_applied == 0 || item.applied_week > SelectedWeek) ?
                        <Trans>Available Booster</Trans> :
                        <>
                          {
                            item.applied_week == SelectedWeek &&
                            <>
                              <Trans>Applied</Trans>: {selected_league.week_abbr[item.applied_week]}
                              {
                                BoosterPosting && item.type != 0 ?
                                  <i className="icon-close disabled" />
                                  :
                                  (item.applied_week == SelectedWeek && SelectedWeek == next_week && item.is_removable == 1) &&
                                  <i className="icon-close click" onClick={(e) => RemoveBooster(e, item.type)} />
                              }
                            </>
                          }
                          {
                            item.applied_week < SelectedWeek &&
                            <><Trans>Played</Trans>: {selected_league.week_abbr[item.applied_week]}</>
                          }
                        </>
                    }
                  </div>
                  <b>{item.label}</b>
                </div>
              </div>
            )
          })
        }

        {
          true &&
          <>
            {
              !_.isEmpty(booster_list) &&
              _.map(booster_list, (item, i) => {
                
                return (
                  
                    
                    <UncontrolledPopover key={i}
                    placement="bottom"
                    target={`BoosterType${item.type}`}
                    trigger="legacy"
                    hideArrow
                    disabled={
                      (SelectedWeek != next_week)
                      || (next_week == last_week && last_week == active_week)
                      || (item?.applied_week &&  item.applied_week != 0 && item.applied_week < next_week)
                      || BoosterPosting
                      || read_only
                    }
                  >
                    <PopoverBody className='booster-popover'>
                      <div>
                        <Banner type="14" style={{ height: '106px', width: '34px' }} bannerLobby={true}/>
                      </div>
                      <div className="booster-img">
                        <span style={{ fontSize: '10px' }}>Official Partner</span>
                        <br />
                        <img src={Images[`BOOSTER_${item.type}`]} alt="" />
                      </div>
                      <div className="booster-title">
                        {item.label}
                      </div>
                      <p>{item.text}</p>
                     

                      {
                        !IS_FROM_LEADER &&  (item.is_applied == 0 || item.applied_week > SelectedWeek) ?

                          <>
                            {
                              Utils.isCapAvailable(LineupList) ?
                                <Button block onClick={() => ApplyBooster(item.type, this.isAlreadyApplyied(item.type))}
                                  disabled={
                                    BoosterPosting
                                    || (joined_week == next_week && item.type == 3)
                                  }><Trans>Apply</Trans></Button>
                                :
                                <Alert color="danger" className='over-budget-msz'><Trans>Choose player to make captain first, Then you will be able to apply 3X booster</Trans></Alert>
                            }
                          </>

                          :
                          <>
                            {
                             !IS_FROM_LEADER && item.applied_week == SelectedWeek &&
                              <>
                                {
                                  item.is_removable == 1 ?
                                    <Button block className='applied' disabled={BoosterPosting} onClick={(e) => RemoveBooster(e, item.type)}><Trans>Remove</Trans></Button>
                                    :
                                    <Button block disabled><Trans>Applied</Trans></Button>
                                }
                              </>
                            }
                            {
                              !IS_FROM_LEADER && item.applied_week &&  item.applied_week < SelectedWeek &&
                              <Button block className='played'><Trans>Played</Trans></Button>
                            }
                          </>
                      }
                    </PopoverBody>
                  </UncontrolledPopover>
            
                
                )
              })
            }
          </>
        }
      </div>
    );
  }
}
// booster_list
Booster.defaultProps = {
  booster_list: [],
  read_only: false
}
export default ReduxHOC(Booster);